import React from "react";
import styles from './AirlineLogoText.module.scss';

interface IAirlineLogoTextProps {
  text: string;
}


const AirlineLogoText = (props: IAirlineLogoTextProps) => {
  return (
    <span className={styles.airlineLogoText}>
      {props.text}
    </span>
  );
};

AirlineLogoText.defaultProps = {
  text: '',
};

export default React.memo(AirlineLogoText);
